"use strict";
exports.__esModule = true;
exports.TileSurveyCTA = exports.TileType = exports.TileFormat = void 0;
var TileFormat;
(function (TileFormat) {
    TileFormat["square"] = "square";
    TileFormat["rectangle"] = "rectangle";
})(TileFormat = exports.TileFormat || (exports.TileFormat = {}));
var TileType;
(function (TileType) {
    TileType["popin"] = "popin";
    TileType["image"] = "image";
    TileType["gif"] = "gif";
    TileType["survey"] = "survey";
})(TileType = exports.TileType || (exports.TileType = {}));
var TileSurveyCTA;
(function (TileSurveyCTA) {
    TileSurveyCTA["swap"] = "swap";
})(TileSurveyCTA = exports.TileSurveyCTA || (exports.TileSurveyCTA = {}));
//# sourceMappingURL=tile.js.map